import React from 'react';

const Footer = ({ onNavigate }) => {
    const links = [
        { label: 'Privacy Policy', path: '/privacy' },
        { label: 'Terms of Service', path: '/terms' },
        { label: 'Contact Support', path: '/contact' },
        { label: 'Copyright Note', path: '/copyright' },
        { label: 'Disclaimer', path: '/disclaimer' },
        { label: 'Imprint', path: '/imprint' },
        { label: 'About', path: '/about' },
    ];

    return (
        <footer className="w-full bg-white dark:bg-slate-900 border-t border-gray-200 dark:border-slate-800 py-8 mt-12 transition-colors duration-200">
            <div className="max-w-7xl mx-auto px-4 lg:px-8">
                <div className="flex flex-col md:flex-row justify-between items-center gap-6">
                    <div className="text-sm text-gray-500 dark:text-slate-400">
                        © {new Date().getFullYear()} BrieflyCA. All rights reserved.
                    </div>

                    <nav className="flex flex-wrap justify-center gap-6">
                        {links.map((link) => (
                            <a
                                key={link.path}
                                href={`#${link.path}`}
                                onClick={(e) => {
                                    // If we wanted to intercept standard navigation, we could.
                                    // For hash routing, standard <a href="#"> works fine, 
                                    // but we can also use a handler if we need to close menus etc.
                                }}
                                className="text-sm text-gray-600 hover:text-gray-900 dark:text-slate-400 dark:hover:text-slate-200 transition-colors"
                                target="_self"
                            >
                                {link.label}
                            </a>
                        ))}
                    </nav>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
